<template>
  <div>
    <v-form v-model="valid" ref="searchForm">
      <v-card dark style="border-radius: 10px">
        <v-layout row wrap class="pa-3">
          <v-flex s12 sm2 class="pl-2 search__input" v-if="province">
            <v-layout column>
              <v-flex>Province :</v-flex>
              <v-flex>
                <v-select
                  v-model="$store.state[action_method].config_path.province_id"
                  item-text="province_name_th"
                  item-value="province_id"
                  :items="provinceList"
                  hide-details
                  @change="
                    fetchDistrictList(
                      $store.state[action_method].config_path.province_id
                    )
                  "
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            s12
            sm2
            class="pl-2 search__input"
            v-if="
              'district_id' in $store.state[action_method].config_path &&
                ('province_id' in $store.state[action_method].config_path ==
                  false ||
                  $store.state[action_method].config_path.province_id != 0)
            "
          >
            <v-layout column>
              <v-flex>District:</v-flex>
              <v-flex>
                <v-select
                  :loading="isLoadingDistrict"
                  v-model="
                    $store.state[action_method].config_path.district_id[0]
                  "
                  item-text="district_name_th"
                  item-value="district_id"
                  :items="districtList"
                  hide-details
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm3 class="pl-2 search__input">
            <v-layout column>
              <v-flex>Start :</v-flex>
              <v-flex>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width:100%"
                >
                  <v-text-field
                    v-model="
                      $store.state[action_method].config_path.datetime_start
                    "
                    slot="activator"
                    prepend-icon="event"
                    hide-details
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    color="#333"
                    v-model="
                      $store.state[action_method].config_path.datetime_start
                    "
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm3 class="pl-2 search__input">
            <v-layout column>
              <v-flex>End :</v-flex>
              <v-flex>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width:100%"
                >
                  <v-text-field
                    v-model="
                      $store.state[action_method].config_path.datetime_end
                    "
                    slot="activator"
                    prepend-icon="event"
                    hide-details
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    color="#333"
                    v-model="
                      $store.state[action_method].config_path.datetime_end
                    "
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-spacer></v-spacer>
          <v-flex
            xs12
            sm2
            style="display: flex; justify-content: center"
            class="mt-3"
          >
            <div class="pt-2 text-xs-center search-btn" @click="search()">
              <v-progress-circular
                indeterminate
                color="black"
                v-if="searching"
              ></v-progress-circular>
              <v-icon large color="black" v-else>search</v-icon>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    searching: {
      default() {
        return false;
      },
    },
    action_method: {
      default() {
        return "fetchPromotionReport";
      },
    },
    province: {
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      valid: true,
      provinceList: [
        {
          province_id: 0,
          province_name_th: "All",
        },
      ],
      districtList: [
        {
          district_id: 0,
          district_name_th: "ทุกอำเภอ",
          district_name_en: "All district",
        },
      ],
      menu1: false,
      menu2: false,
      date: new Date().toISOString().substr(0, 10),
      isLoadingDistrict: false,
    };
  },
  created() {
    if (this.province) {
      this.provinceList = [...this.provinceList, ...this.provinceData];
    }

    if (this.province == true) {
      if (this.$store.state[this.action_method].config_path.province_id == 0)
        return;
      this.fetchDistrictList(
        this.$store.state[this.action_method].config_path.province_id
      );
    } else {
      this.fetchDistrictList();
    }
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      provinceNameEn: (state) => state.backOffice.province,
    }),
  },
  methods: {
    ...mapActions({
      fetchDistrictCore: "fetchProvinceBack/getDistrictCore",
    }),
    async search() {
      if (this.searching == false) {
        if (this.$refs.searchForm.validate()) {
          this.$emit("search");
        }
      }
    },
    async fetchDistrictList(province_id) {
      this.isLoadingDistrict = true;
      let province;
      console.log(province_id);
      if (this.province == true) {
        this.districtList = [
          {
            district_id: 0,
            district_name_th: "ทุกอำเภอ",
            district_name_en: "All district",
          },
        ];
        this.$store.state[this.action_method].config_path.district_id.splice(
          0,
          1,
          0
        );
      }
      if (province_id == undefined) {
        province = this.provinceData.find(
          (val) =>
            val.province_name_en.replace(/ /g, "").toLowerCase() ===
            this.provinceNameEn.toLowerCase()
        );
      }
      let payload =
        province_id == undefined ? province.province_id : province_id;
      let districtByProvince = await this.fetchDistrictCore(payload);
      this.districtList = [...this.districtList, ...districtByProvince];
      this.isLoadingDistrict = false;
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
}

@media screen and (max-width: 662px) {
  .search__input {
    margin-top: 20px;
  }
}
</style>
